<template>
  <v-layout
    row
    pb-2>
    <v-flex
      xs12
      md8
      offset-md2
      lg6
      offset-lg3>
      <v-card class="card--flex-toolbar">
        <app-secondary-toolbar
          title="Categorieën" />
        <v-divider />
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="(category) in categoryList"
              :key="category._id"
              :to="{ name: 'productList', params: { categoryId: category._id } }">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ category.title[0].text }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-chip small>
                  {{ category.products.length }} {{ productsLabel(category.products.length) }}
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios-auth";
import appSecondaryToolbar from "@/components/TheSecondaryToolbar";

export default {
  name: "CategoryList",
  components: {
    appSecondaryToolbar
  },
  data: () => ({
    categoryList: {}
  }),
  created() {
    this.fetchCategories();
  },
  methods: {
    fetchCategories() {
      axios.get("/categories", { headers: { "x-locale": "nl-be" } })
        .then((response) => {
          this.categoryList = response.data.categories;
        });
    },
    productsLabel(productCount) {
      if (productCount === 1) return "product";
      return "producten";
    }
  }
};
</script>
